<template>
  <div>
    <div class="common-header">
      <router-link :to="{ name: 'onlinePlayerPushList' }">
        <el-button type="primary">推送列表</el-button>
      </router-link>
      <el-button
        @click="getList()"
        style="margin-left: 10px"
        class="el-icon-refresh"
        type="primary"
        plain
      >
        刷新
      </el-button>
      <div class="common-header-right">
        <div class="common-header-block">
          用户层级：
          <el-select
            style="width: 240px"
            multiple
            collapse-tags
            v-model="userLevelScores"
          >
            <el-option
              v-for="item of userLevelOptions"
              :key="item.label"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
        <div class="common-header-block">
          <el-input placeholder="请输入玩家昵称或ID" v-model="searchVal">
            <template slot="prepend">玩家</template>
          </el-input>
        </div>
        <div class="common-header-block">
          <el-button type="primary" @click="getList()">搜索</el-button>
        </div>
      </div>
    </div>
    <div v-if="permissions.osm_all_field">
      <strong
        class="common-text-item"
        v-text="`在线玩家总数：${userOnlineList.total}`"
      ></strong>
      <strong
        class="common-text-item"
        v-text="`${userLevelArr[1]}：${userOnlineList.whiteListCount}`"
      ></strong>
      <strong
        class="common-text-item"
        v-text="`${userLevelArr[2]}：${userOnlineList.greenListCount}`"
      ></strong>
      <strong
        class="common-text-item"
        v-text="`${userLevelArr[3]}：${userOnlineList.grayListCount}`"
      ></strong>
      <strong
        class="common-text-item"
        v-text="`${userLevelArr[4]}：${userOnlineList.orangeListCount}`"
      ></strong>
      <strong
        class="common-text-item"
        v-text="`${userLevelArr[5]}：${userOnlineList.blackListCount}`"
      ></strong>
    </div>
    <div class="common-table">
      <el-table
        v-loading="loading"
        :data="userOnlineList.beanList"
        @sort-change="sortChange"
        @expand-change="expandChange"
        :row-key="(row) => JSON.stringify(row)"
        height="100%"
      >
        <el-table-column type="expand">
          <div slot-scope="scope" class="table-expand">
            <span
              class="item"
              v-text="`总保险：${scope.row.totalInsurance}记分牌`"
            ></span>
            <span class="item" v-text="`总手数：${scope.row.totalHand}`"></span>
            <span
              class="item"
              v-text="`总房间数：${scope.row.totalGame}`"
            ></span>
            <span
              class="item"
              v-text="`总带入次数：${scope.row.totalTakeIn}`"
            ></span>
            <span
              class="item"
              v-text="`JP贡献：${scope.row.totalDedicationJp}记分牌`"
            ></span>
            <span
              class="item"
              v-text="`JP奖励：${scope.row.totalJpReward}记分牌`"
            ></span>
            <span
              class="item"
              v-text="`奥马哈总积分：${scope.row.omahaProfit}记分牌`"
            ></span>
            <span
              class="item"
              v-text="`AOF总积分：${scope.row.aofProfit}记分牌`"
            ></span>
            <span
              class="item"
              v-text="`总赠送金豆：${scope.row.totalGiftChip}金豆`"
            ></span>
            <span
              class="item"
              v-text="`玩家ID：${scope.row.userRandomId}`"
            ></span>
            <span
              class="item"
              v-text="`所属俱乐部：${scope.row.clubName}`"
            ></span>
            <span
              class="item"
              v-text="`所属联盟：${scope.row.tribeName}`"
            ></span>
            <span
              class="item"
              v-text="`UCV：${scope.row.ucv / 100}记分牌`"
            ></span>
            <span
              class="item"
              v-text="`德州入池率：${scope.row.dzPoolRate}%`"
            ></span>
            <span class="item"
              >最近带入地点：
              <template v-if="scope.row.currentEquipment === 'simulator'"
                >虚拟定位</template
              >
              <location-to-city
                v-else
                :location="`${scope.row.bringLongitude},${scope.row.bringLatitude}`"
            /></span>
            <span
              class="item"
              v-text="`IP关联：${scope.row.firstLevelIpRelevance}`"
            ></span>
            <span
              class="item"
              v-text="`设备关联：${scope.row.firstLevelEquipmentRelevance}`"
            ></span>
          </div>
        </el-table-column>
        <el-table-column label="编号" type="index" align="center" />
        <el-table-column label="用户层级" min-width="220" align="center">
          <template slot-scope="scope">
            <!--T名单-->
            <template v-if="scope.row.level === 6">{{
              userLevelArr[scope.row.level]
            }}</template>
            <select-set-value
              v-else
              class="select-set-value"
              :list="userLevelOptions"
              :text="userScoreAndLevel[`${scope.row.score},${scope.row.level}`]"
              @my-submit="updateLevelFunc($event, scope.row.userId)"
            />
          </template>
        </el-table-column>
        <el-table-column label="层级来源" align="center">
          <span
            slot-scope="scope"
            v-text="
              scope.row.isAuto ? '自动' : scope.row.isAuto === '' ? '' : '手动'
            "
          ></span>
        </el-table-column>
        <el-table-column label="标签" min-width="220" align="center">
          <template slot-scope="scope">
            <select-set-value
              class="select-set-value"
              :list="userLabelOptions"
              :text="scope.row.userLabel"
              @my-submit="updateLabelFunc($event, scope.row.userId)"
            />
          </template>
        </el-table-column>
        <el-table-column label="玩家昵称" min-width="180" align="center">
          <template slot-scope="scope"
            >{{ scope.row.userNickname }}
            <i v-show="scope.row.isNewPlayer" class="icon-new"></i
          ></template>
        </el-table-column>
        <el-table-column label="加权状态" min-width="180" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.weightingStatus == 0">未加权</span>
            <span v-else-if="scope.row.weightingStatus == 1">永久注销加权</span>
            <span v-else-if="scope.row.weightingStatus == 2">新用户加权</span>
            <span v-else-if="scope.row.weightingStatus == 3">浅水加权</span>
            <span v-else-if="scope.row.weightingStatus == 4">深水加权</span>
            <span v-else-if="scope.row.weightingStatus == 5">回归加权</span>
            <span v-else-if="scope.row.weightingStatus == 6">手工加权</span>
          </template>
        </el-table-column>
        <el-table-column
          sortable="custom"
          min-width="150"
          align="center"
          label="当前房间"
          prop="currentRoomName"
        />
        <el-table-column min-width="120" label="房间盲注级别" align="center">
          <template slot-scope="scope">{{
            scope.row.blind | blindNoteNumber
          }}</template>
        </el-table-column>
        <el-table-column
          sortable="custom"
          min-width="150"
          align="center"
          label="德州总积分"
          prop="dzProfit"
        />

        <!--<el-table-column sortable="custom" min-width="150" label="德州入池率" align="center">
                    <template slot-scope="scope">{{scope.row.dzPoolRate}}%</template>
                </el-table-column>-->
        <el-table-column
          sortable="custom"
          min-width="160"
          align="center"
          label="近7天的盈亏环比"
        >
          <template slot-scope="scope"
            >{{ (scope.row.profitLossRatio * 100) | roundNumber }}%</template
          >
        </el-table-column>
        <el-table-column
          sortable="custom"
          min-width="200"
          align="center"
          label="充值成功金额（记分牌）"
          prop="rechargeSuccessAmount"
        />
        <el-table-column
          sortable="custom"
          min-width="200"
          align="center"
          label="提现成功金额（记分牌）"
          prop="extractSuccessAmount"
        />
        <el-table-column
          sortable="custom"
          min-width="120"
          align="center"
          label="充提差"
          prop="rechargeExtractSubtract"
        />
        <el-table-column
          label="注册时间"
          min-width="150"
          align="center"
          prop="registerTime"
        />
        <el-table-column label="当前设备" min-width="150" align="center">
          <template slot-scope="scope">{{
            scope.row.currentEquipment | equipmentName
          }}</template>
        </el-table-column>
        <el-table-column label="常用设备" min-width="150" align="center">
          <template slot-scope="scope">{{
            scope.row.commonEquipment | equipmentName
          }}</template>
        </el-table-column>
        <el-table-column width="100" align="center">
          <template slot-scope="scope">
            <comp-remark :userId="scope.row.userId" />
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="common-el-pagination"
      background
      layout="prev,pager,next,jumper"
      :page-size="20"
      :pager-count="5"
      :total="userOnlineList.total"
      @current-change="getList($event)"
      :current-page="currentPage"
    />
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
import locationToCity from "components/locationToCity";
import selectSetValue from "components/selectSetValue";
import compRemark from "./compRemark";

export default {
  components: {
    locationToCity,
    selectSetValue,
    compRemark,
  },
  data() {
    return {
      loading: false,
      searchVal: "",
      userLevelScores: [],
      soryDataType: 0, // 排序字段
      sortType: "", // 排序类型
      currentPage: 1,
    };
  },
  computed: {
    ...mapGetters("user", [
      "userLevelArr",
      "userScoreAndLevel",
      "userLevelOptions",
      "userLabelOptions",
    ]),
    ...mapState("userOnline", ["userOnlineList"]),
    ...mapState("login", ["permissions"]),
  },
  created() {
    this.getUserLabelList();
    this.getUserLevelConfigList();
    this.getList();
  },
  filters: {
    roundNumber(num) {
      return Math.round(num);
    },
  },
  methods: {
    ...mapActions("user", [
      "getUserLevelConfigList",
      "getUserLabelList",
      "setUserAddLabel",
    ]),
    ...mapActions("userOnline", [
      "getUserOnlineList",
      "getUserOnlineExpand",
      "updateUserLevel",
    ]),
    sortChange(e) {
      let orderField = [
        "",
        "dzProfit",
        "dzPoolRate",
        "roundNumber",
        "rechargeSuccessAmount",
        "extractSuccessAmount",
        "rechargeExtractSubtract",
        "currentRoomName",
      ];
      this.soryDataType = e.order ? (e.order === "descending" ? 2 : 1) : 0;
      this.sortType = e.prop ? orderField.indexOf(e.prop) : "";
      this.getList();
    },
    getList(page = 1) {
      this.loading = true;
      this.currentPage = page;
      this.getUserOnlineList({
        page,
        soryDataType: this.soryDataType,
        sortType: this.sortType,
        userLevelScores: this.userLevelScores.map((item) => {
          return {
            score: +item.split(",")[0],
            level: +item.split(",")[1],
          };
        }),
        userRandomId: this.searchVal,
      }).then(() => {
        this.loading = false;
      });
    },
    updateLevelFunc({ value, cb }, userId) {
      this.updateUserLevel({
        level: value.split(",")[1],
        score: value.split(",")[0],
        userId,
      }).then(() => {
        cb();
        this.$message.success("修改成功");
        this.getList(this.currentPage);
      });
    },
    updateLabelFunc({ value, cb }, userId) {
      if (value) {
        this.setUserAddLabel({
          labelConfigId: value,
          userId,
        }).then(() => {
          cb();
          this.$message.success("修改成功");
          this.getList(this.currentPage);
        });
      } else {
        this.$message.error("标签不能为空");
      }
    },
    expandChange(row, expandedRows) {
      expandedRows.forEach((item) => {
        if (item.userId === row.userId) {
          this.loading = true;
          this.getUserOnlineExpand(row.userId).then((res) => {
            Object.assign(row, res.data);
            this.loading = false;
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.table-expand {
  .item {
    display: inline-block;
    padding: 2px 20px;
  }
}
</style>
